export async function generateInstagramStory({ title, posterUrl }) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = 1080;
  canvas.height = 1920;

  /* ======================================================
     BACKGROUND
  ====================================================== */
  const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
  gradient.addColorStop(0, "#26005aff");
  gradient.addColorStop(1, "#050008");
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  /* ======================================================
     HELPER: load image SAFELY (iOS)
  ====================================================== */
  const loadImage = async (src) => {
    try {
      const res = await fetch(src, { mode: "cors" });
      if (!res.ok) throw new Error("Fetch failed");

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      return await new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          URL.revokeObjectURL(url);
          resolve(img);
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(null);
        };
        img.src = url;
      });
    } catch (e) {
      console.warn("Image load failed:", src);
      return null;
    }
  };


  /* ======================================================
     LOGO
  ====================================================== */
  const logo = await loadImage("/logouflixfull.png");
  if (logo) {
    const logoWidth = 350;
    const logoHeight = (logo.height / logo.width) * logoWidth;
    const logoY = 140;

    ctx.drawImage(
      logo,
      (canvas.width - logoWidth) / 2,
      logoY,
      logoWidth,
      logoHeight
    );
  }

  /* ======================================================
     POSTER
  ====================================================== */
  const poster = posterUrl ? await loadImage(posterUrl) : null;

  if (poster) {
    const w = 600;
    const h = 900;
    const x = (canvas.width - w) / 2;
    const y = 380;
    const radius = 40;

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + w - radius, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
    ctx.lineTo(x + w, y + h - radius);
    ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
    ctx.lineTo(x + radius, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();

    ctx.shadowColor = "rgba(0, 0, 0, 0.86)";
    ctx.shadowBlur = 40;

    ctx.clip();
    ctx.drawImage(poster, x, y, w, h);
    ctx.restore();
  }

  /* ======================================================
     TITLE
  ====================================================== */
  ctx.fillStyle = "#ffffff";
  ctx.font = "bold 64px Inter, sans-serif";
  ctx.textAlign = "center";
  ctx.fillText(title || "", canvas.width / 2, 1400);

  /* ======================================================
     SUBTITLE
  ====================================================== */
  ctx.font = "36px Inter, sans-serif";
  ctx.fillStyle = "#d0c7ff";
  ctx.fillText("Watch on uFlix", canvas.width / 2, 1480);

  /* ======================================================
     LINK
  ====================================================== */
  ctx.font = "28px Inter, sans-serif";
  ctx.fillStyle = "#b8aaff";
  ctx.fillText("www.uflix.space", canvas.width / 2, 1540);

  return canvas;
}
